import React, {Component} from 'react';
import {Button} from "reactstrap";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {Spinner} from "../../Spinner";
import {CredentialRow} from "./CredentialRow";
import {AddCredentialModal} from "./AddCredentialModal";
import {SendConnectionLinkModal} from "../../connection_links/SendConnectionLinkModal";
import {
    GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL, ANALYTICS_CHANNEL,
    SEARCH_CONSOLE_CHANNEL, DV360_CHANNEL, ESCALAFY_CHANNEL, MERCADO_ADS_CHANNEL
} from "../../channels/channels";
import { withTranslation } from 'react-i18next';


const CHANNEL_DISPLAY_NAMES = {
    [GOOGLE_CHANNEL]: 'Google Ads',
    [FACEBOOK_CHANNEL]: 'Meta Ads',
    [TIKTOK_CHANNEL]: 'TikTok Ads',
    [LINKEDIN_CHANNEL]: 'LinkedIn Ads',
    [ANALYTICS_CHANNEL]: 'GA4',
    [SEARCH_CONSOLE_CHANNEL]: 'Google Search Console',
    [DV360_CHANNEL]: 'Display & Video 360',
    [MERCADO_ADS_CHANNEL]: 'Mercado Ads',
    [ESCALAFY_CHANNEL]: 'Escalafy',
};

class ChannelCredentialsListClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaving: false,
            // «Enviar un link nuevo al vendedor» (Mercado Ads): `null` cerrado; `{agencyClientId}` abierto.
            sendLink: null,
        };
        this.handleCredentialRemoved = this.handleCredentialRemoved.bind(this);
        this.openSendLink = this.openSendLink.bind(this);
    }

    openSendLink(credential) {
        const agencyClientId = credential && (credential.managed_by_client_id || credential.agency_client_id);
        this.setState({sendLink: {agencyClientId: agencyClientId || null}});
    }

    handleCredentialRemoved(credentialId) {
        this.props.onCredentialRemoved(this.props.channel, credentialId);
    }

    renderCredentialsTable() {
        const { credentials, t } = this.props;

        if (!credentials || credentials.length === 0) {
            return null;
        }

        return (
            // A 390 px la tabla (sobre todo con «Gestionada por…» y el aviso de vencimiento) es más ancha
            // que la caja y `.app-content` corta el desborde: sin scroll propio, «Reconectar» quedaba
            // fuera de pantalla e inalcanzable (QA-linkedin-12). La tabla scrollea dentro de su caja.
            <div className="table-box" style={{overflowX: 'auto'}}>
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th>{t('channel_credentials_list.label')}</th>
                        <th>{t(this.props.channel === ESCALAFY_CHANNEL
                            ? 'channel_credentials_list.organizations'
                            : 'channel_credentials_list.ad_accounts')}</th>
                        <th>{t('channel_credentials_list.connected_since')}</th>
                        <th>{t('channel_credentials_list.actions')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {credentials.map((cred) =>
                        <CredentialRow key={cred.id}
                                       credential={cred}
                                       channel={this.props.channel}
                                       onRemove={this.handleCredentialRemoved}
                                       onCredentialUpdated={this.props.onCredentialUpdated}
                                       onSendLink={this.openSendLink}
                                       isSaving={this.state.isSaving}
                        />
                    )}
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        // `title`, `subtitle` y `newConnectionLabel` son para una sección que se nombra por su FAMILIA y no
        // por el canal («Rentabilidad del negocio», con «Conectar Escalafy» como botón).
        const { channel, credentials, t, title, newConnectionLabel, className } = this.props;
        const displayName = title || CHANNEL_DISPLAY_NAMES[channel] || channel;
        // Mercado Ads no se conoce como canal de pauta: el subtítulo dice qué es.
        const subtitle = this.props.subtitle || (channel === MERCADO_ADS_CHANNEL ? t('channels.mercado_ads.subtitle') : null);
        const boxClassName = `section-body-item -wider box${className ? ` ${className}` : ''}`;

        if (credentials === null || credentials === undefined) {
            return (
                <div className={boxClassName}>
                    <div className="box-loader">
                        <Spinner color="positive"/>
                    </div>
                </div>
            );
        }

        return (
            <div className={boxClassName} style={{minWidth: 0}}>
                <header className="box-header">
                    <h2 className="box-title"><ChannelLogo channel={channel}/> {displayName}</h2>
                    <div className="float-right">
                        <Button className="-alt" onClick={(e) => {e.stopPropagation(); this.addCredentialModal.toggle()}}>
                            {newConnectionLabel || t('channel_credentials_list.new_connection')}
                        </Button>
                        <AddCredentialModal
                            ref={instance => { this.addCredentialModal = instance; }}
                            channel={channel}
                        />
                    </div>
                </header>
                {subtitle && <p className="field-footnote-darker channel-credentials-subtitle">{subtitle}</p>}
                {this.renderCredentialsTable()}
                {channel === MERCADO_ADS_CHANNEL && (
                    <SendConnectionLinkModal show={this.state.sendLink !== null}
                                             onHide={() => this.setState({sendLink: null})}
                                             channel={MERCADO_ADS_CHANNEL}
                                             agencyClientId={(this.state.sendLink && this.state.sendLink.agencyClientId) || undefined}/>
                )}
            </div>
        );
    }
}

export const ChannelCredentialsList = withTranslation()(ChannelCredentialsListClass);
export default ChannelCredentialsList;
